import { Author } from 'types';
import Image from 'next/image';
import { images } from 'sdk';
import styles from '~/styles/components/author/author-image.module.scss';
import {
  updateFirestoreDoc,
  updateAuthorImage,
} from '~/clients/firebase/client';
import EditFilledSVG from '~/assets/svg/icons/edit-filled';

interface AuthorImageProps {
  author: Author;
  user: any;
  photo_url: string;
  isAdmin: boolean;
}

export default function AuthorImage({
  author,
  user,
  photo_url,
  isAdmin,
}: AuthorImageProps) {
  async function handleAuthorImage(event) {
    const fileName = author?.id + '.jpeg';
    const photo_url = await updateAuthorImage(event.target.files[0], fileName);

    if (photo_url) {
      try {
        await updateFirestoreDoc('author_content', author?.id, {
          photo_url: `author_images/${fileName}`,
          updated_by: user?.name,
          updated_at: new Date(),
        });
      } catch (e) {
        console.log(e);
      }
    }
  }

  return (
    <>
      {isAdmin && user && (
        <div className={styles['edit-icon-container']}>
          <label htmlFor='file-folder'>
            <EditFilledSVG />
          </label>
          <div className={styles['hidden']}>
            <input
              id='file-folder'
              onChange={handleAuthorImage}
              type='file'
              accept='/image/*'
            />
          </div>
        </div>
      )}
      <Image
        src={images(photo_url).user.profileImage}
        alt='Author image'
        width={130}
        height={130}
        className={styles['author-img']}
        unoptimized
      />
    </>
  );
}
